<template> 
   <div v-show="showCondition" > 
       <Row v-if="showFormBox" type="flex" justify="start" align="middle" >
            <Col span='18'>
                <FormBox ref="form" :config="formConfig" :dictData="dictData"/>
            </Col>
            <Col span='6'>
                <Row type="flex" justify="end" align="middle"  >
                    <Col>
                        <Button customIcon="iconfont icon-custom-search" type="primary"  style="width:80px" @click="search">查询</Button>
                    </COl>
                    <Col style="margin-left:10px">
                        <Button  customIcon="iconfont icon-custom-reset"  style="width:80px" @click="doClear">重置</Button>
                    </Col>
                </Row>
            </Col>
      </Row>   
  </div>
</template>
<script>
    import Base from './queryconditionboxbase.vue';
    export default {
        name: 'queryconditionbox',
        extends: Base,
    };
</script>


// WEBPACK FOOTER //
// src/components/conditionbox/queryconditionbox.vue